function renderCreateNextConfigTemplateImportsTemplate({
  betterstartAssetHost
}: {
  betterstartAssetHost: string
}): string {
  return `import type { NextConfig } from 'next'

const nextConfig: NextConfig = {
  cacheComponents: true,
  partialPrefetching: true,
  devIndicators: false,
  images: {
    remotePatterns: [
      {
        protocol: 'https',
        hostname: '${betterstartAssetHost}',
      },
    ],
  },
}

export default nextConfig
`
}

function renderCreateNextConfigTemplateImportsDetailsTemplate({
  betterstartAssetHost
}: {
  betterstartAssetHost: string
}): string {
  return `import type { NextConfig } from 'next'

const nextConfig: NextConfig = {
  experimental: {
    useCache: true,
  },
  images: {
    remotePatterns: [
      {
        protocol: 'https',
        hostname: '${betterstartAssetHost}',
      },
    ],
  },
}

export default nextConfig
`
}

export function renderCreateNextConfigTemplateRenderer(
  request:
    | {
        kind: 'renderCreateNextConfigTemplateImportsTemplate'
        props: {
          betterstartAssetHost: string
        }
      }
    | {
        kind: 'renderCreateNextConfigTemplateImportsDetailsTemplate'
        props: {
          betterstartAssetHost: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderCreateNextConfigTemplateImportsTemplate':
      return renderCreateNextConfigTemplateImportsTemplate(request.props)
    case 'renderCreateNextConfigTemplateImportsDetailsTemplate':
      return renderCreateNextConfigTemplateImportsDetailsTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
